var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessonNextArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 -1.65527e-05C11.0218 -1.65527e-05 7.2065 1.58036 4.39325 4.39323C1.58025 7.20623 0 11.0217 0 15C0 18.9782 1.58037 22.7935 4.39325 25.6067C7.20625 28.4197 11.0218 30 15 30C17.633 30 20.2197 29.3069 22.5 27.9904C24.7803 26.6738 26.6737 24.7802 27.9905 22.4999C29.307 20.2196 30.0001 17.6329 30.0001 14.9999C30.0001 11.0217 28.4197 7.20641 25.6068 4.39316C22.7938 1.58016 18.9783 -9.15527e-05 15.0001 -9.15527e-05L15 -1.65527e-05ZM22.5 15.03C22.5051 15.3561 22.3773 15.6701 22.146 15.9L17.208 20.823C16.903 21.1284 16.4583 21.248 16.0413 21.1367C15.6243 21.0254 15.2984 20.7 15.1863 20.2832C15.0743 19.8664 15.1931 19.4214 15.498 19.116L18.3901 16.221H8.70005C8.27135 16.221 7.87515 15.9922 7.6608 15.621C7.44645 15.2497 7.44645 14.7923 7.6608 14.421C7.87516 14.0497 8.27135 13.821 8.70005 13.821H18.4171L15.498 10.902H15.4981C15.1927 10.5966 15.0733 10.1513 15.1851 9.73408C15.297 9.31681 15.6228 8.99083 16.0401 8.87901C16.4574 8.76729 16.9026 8.88653 17.2081 9.19201L22.1461 14.115C22.3736 14.3412 22.5012 14.6491 22.5001 14.97L22.5 15.03Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonNextArrow);
export default __webpack_public_path__ + "static/media/lessonNextArrow.0fc6eb34332371238aa5d469ff23acde.svg";
export { ForwardRef as ReactComponent };